module.exports = __webpack_public_path__ + "media/wrong_answer.f6a89b6d.mp3";